import styled from "styled-components";

export const BottomModal = styled.div`
  &.btmSheet--fixTop {
    align-items: flex-start;
    padding-top: 60px;
  }

  &.btmSheet--fixTop30 {
    align-items: flex-start;
    padding-top: 30px;
  }

  &.btmSheet--black {
    background-color: #000000;
    .cm__clseBtn {
      top: 30px;
      &::after, &::before{
        background-color: #ffffff;
      }
    }
  }
`;